import React from 'react';
import { Typography } from 'fronton-react';

type TFunction = (param: string) => string;

const getSubheader = (translate?: TFunction) =>
  translate ? translate('calculator.dimensions.subheader.main') : 'Рассчитаем количество товара';
const getComplementarySubheader = (translate?: TFunction) =>
  translate
    ? translate('calculator.dimensions.subheader.complimentary')
    : ', подберем инструменты и расходники';

export const getDimensionsFormSubheading = (
  isMobile: boolean | null,
  isHaveComplimentaryProduct: boolean,
  translate?: TFunction
) => (
  <Typography
    size="body_long"
    variant={isMobile ? 's' : 'l'}
    color="text-primary"
    data-testid="dimensions-subtitle">
    {getSubheader(translate)}
    {isHaveComplimentaryProduct ? getComplementarySubheader(translate) : ''}
  </Typography>
);
